import { Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/AppLoader";
import { CustomContainer } from "../../../components/Containers";
import GlobalButton from "../../../components/CustomButton";
import NavigationDrawer from "../../../components/NavigationDrawer";
import appcolors from "../../../constants/Colors";
import { getCreatorAcceptedCampaigns } from "../../../services/creator/campaignApiFn";
import { handleOpenSnackBar } from "../../../utils";
import CampaignCard from "../campaigns/CampaignCard";

function CreatorDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [myCampaigns, setMyCampaigns] = useState([]);
  const userData = useSelector((state) => state.userData.user);

  const fetchMyCampaigns = async () => {
    if (!userData?._id) return;
    try {
      setIsLoading(true);
      const response = await getCreatorAcceptedCampaigns(userData._id);
      if (response?.data?.status === "success") {
        setMyCampaigns(response.data.data || []);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMyCampaigns();
  }, [userData?._id]);

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={appcolors.gunmetal}
        mb={2}
      >
        {t("welcome")} {t(userData?.username)}
      </Typography>

      <CustomContainer
        primaryHeading={t("myCampaigns")}
        secondaryHeading={t("myCampaignsDescription")}
        customHeaderActions={
          <GlobalButton
            btnText={t("browseCampaigns")}
            handleClickBtn={() => navigate("/creator/campaigns")}
            styleProps={{
              width: "auto",
            }}
          />
        }
      >
        {!isLoading && myCampaigns.length === 0 ? (
          <Stack alignItems="center" py={5}>
            <Typography fontWeight={500}>{t("noAcceptedCampaigns")}</Typography>
          </Stack>
        ) : (
          <Grid container spacing={2}>
            {myCampaigns.map((campaign) => (
              <Grid item xs={12} sm={6} lg={4} key={campaign._id}>
                <CampaignCard campaign={campaign} />
              </Grid>
            ))}
          </Grid>
        )}
      </CustomContainer>
    </NavigationDrawer>
  );
}

export default CreatorDashboard;
